import React from 'react'
import IFormPage from '../../../../../interfaces/form-page'
import DoubtForm from './doubt-form'

import {
  Container,
  Title,
} from './styles'

type IProps = any & IFormPage

const DoubtEditor = ({
  dataForm,
  onSubmit,
  initialData,
  isToUpdate = false,
}: IProps) => (
  <Container>
    <Title>Cadastre as principais dúvidas feitas pelos clientes (opcionais)</Title>

    <DoubtForm
      dataForm={dataForm}
      onSubmit={onSubmit}
      initialData={initialData}
      isToUpdate={isToUpdate}
    />
  </Container>
)

export default DoubtEditor
